var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSolidGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83678 0.723297C9.14286 -0.218717 10.4756 -0.218718 10.7816 0.723296L12.3344 5.50209C12.4712 5.92337 12.8638 6.2086 13.3068 6.2086H18.3315C19.322 6.2086 19.7338 7.47607 18.9325 8.05827L14.8674 11.0117C14.5091 11.2721 14.3591 11.7336 14.496 12.1549L16.0487 16.9337C16.3548 17.8757 15.2766 18.659 14.4753 18.0768L10.4102 15.1234C10.0518 14.863 9.56658 14.863 9.20822 15.1234L5.14314 18.0768C4.34181 18.659 3.26364 17.8757 3.56972 16.9337L5.12244 12.1549C5.25932 11.7336 5.10937 11.2721 4.751 11.0117L0.685923 8.05827C-0.115403 7.47607 0.296423 6.2086 1.28692 6.2086H6.31163C6.75459 6.2086 7.14718 5.92337 7.28406 5.50209L8.83678 0.723297Z",
    fill: "#EFAC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolidGold);
export default __webpack_public_path__ + "static/media/star-solid-gold.e6dc9a97398b34db9afc5cdcceddfb24.svg";
export { ForwardRef as ReactComponent };